var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendEmailBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F4F4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 21.875l2.5 2.5m0 0l-2.5 2.5m2.5-2.5h-6.25",
    stroke: "#3C3F47",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.876 12.375a1.75 1.75 0 00-1.75 1.75v11.75c0 .966.783 1.75 1.75 1.75h7.75v-1.5h-7.75a.25.25 0 01-.25-.25V14.831l6.094 5.078a2 2 0 002.56 0l6.095-5.079v5.795h1.5v-6.5a1.75 1.75 0 00-1.75-1.75h-14.25zm13.302 1.5H13.821l5.859 4.882a.5.5 0 00.64 0l5.858-4.882z",
    fill: "#3C3F47"
  })));
}
export default __webpack_public_path__ + "static/send_email_big.07ea7321.svg";
export { SvgSendEmailBig as ReactComponent };